<div
  class="desktop-label"
  i18n="@@refundablerate_ver_solo_habitaciones_con_cancelacion_gratis"
>
  Ver sólo habitaciones con cancelación gratis
</div>
<div class="mobile-label" i18n="@@refundablerate_cancelacion_gratis">
  Cancelación gratis
</div>
<div class="switch">
  <mb-switch [value]="refundableRateSelected" (change)="setRate()"></mb-switch>
</div>
